export default "__VITE_ASSET__D$6Vdsa1__"